/*eslint-disable*/
import Jazzicon from './Jazzicon.vue';
export { Jazzicon };
export default Jazzicon;
